import styles from './InTheBag.module.scss';
import GreenCheckmarkIcon from '@/assets/icons/green-checkmark.svg?react';
import DashedSquareIcon from '@/assets/icons/dashed-square.svg?react';
import { isMobileResolution } from '@/utils';

interface IInTheBagProps {
  isActive: boolean;
  className?: string;
}

export default function InTheBag({ isActive, className = '' }: IInTheBagProps) {
  return (
    <div className={`${styles.inTheBag} ${className}`}>
      {isActive && (
        <>
          <GreenCheckmarkIcon className={styles.icon} />
          <span className={styles.label}>{isMobileResolution ? 'In' : 'In the bag'}</span>
        </>
      )}
      {!isActive && (
        <>
          <DashedSquareIcon className={styles.icon} />
          <span className={styles.label}>{isMobileResolution ? 'Out' : 'Out of bag'}</span>
        </>
      )}
    </div>
  );
}
